import React from "react";
import { BookOpen, Download, ExternalLink } from "lucide-react";
import ConsolidationPopover from "./ConsolidationPopover.jsx";
import { SECONDARY } from "./Fields.jsx";

const assetBase = import.meta.env?.BASE_URL || "/static/react/";
const GUIDES = [
  {
    title: "Guide simple",
    description: "2 chargements, 2 livraisons et un trajet de 1 h 30 avec Coop et Comax.",
    filename: "facturation_coop_comax_simple.pdf",
  },
  {
    title: "Guide avec préchargement",
    description: "3 chargements chez Coop, Comax et Comptoir Agricole, 3 commandes préchargées et des trajets de 1 h 30.",
    filename: "facturation_trois_chargements_prechargement.pdf",
  },
];

export default function Guides() {
  return <ConsolidationPopover label="Guides de facturation" icon={BookOpen}>
    <div className="grid gap-2">
      <p className="text-xs text-slate-600">Deux exemples illustrés pour comprendre la répartition du temps et l’expliquer à vos clients.</p>
      <div className="grid min-w-0 gap-3 sm:grid-cols-2">
        {GUIDES.map((guide) => {
          const href = `${assetBase}guides/consolidation/${guide.filename}`;
          return <article key={guide.filename} className="flex min-w-0 flex-col gap-2 rounded-[4px] border border-slate-200 p-3">
            <div className="flex flex-wrap items-baseline justify-between gap-x-3 gap-y-1">
              <h3 className="text-sm font-semibold text-slate-800">{guide.title}</h3>
              <span className="text-xs text-slate-500">PDF · 1 page</span>
            </div>
            <p className="flex-1 text-xs text-slate-600">{guide.description}</p>
            <div className="flex flex-wrap gap-2">
              <a href={href} target="_blank" rel="noopener noreferrer" className={SECONDARY} aria-label={`${guide.title} : ouvrir le PDF (nouvel onglet)`}>
                <ExternalLink size={13} aria-hidden="true" />Ouvrir le PDF
              </a>
              <a href={href} download={guide.filename} className={SECONDARY} aria-label={`${guide.title} : télécharger le PDF`}>
                <Download size={13} aria-hidden="true" />Télécharger
              </a>
            </div>
          </article>;
        })}
      </div>
    </div>
  </ConsolidationPopover>;
}
